import Icon from 'veui/components/Icon'
import { IconHierarchy } from 'dls-icons-vue'

Icon.register('hierarchy', IconHierarchy)
